import React, {useState} from 'react';
import {toLower} from "lodash";
import BaseForm from "../../theme/forms/BaseForm";
import validators from "../../../utils/forms/validators";
import {loginUser} from "../../../store/calls";
import {addErrorAlert, clearAllAlerts} from "../../../store/calls/alertLoadingDispatch";



const loginInputs =  [
    {
        type: 'text',
        dataKey: 'username',
        label: 'Username',
        inputClasses: 'is-medium',
        ...validators.isStringOfMinLength(4)
    },
    {
        type: 'password',
        dataKey: 'password',
        label: 'Password',
        inputClasses: 'is-medium',
        ...validators.isStringOfMinLength(4)
    },
];


function LoginForm({ onSuccess, onLoginError: onError }) {

    const [isLoading, setLoading] = useState(false)

    const onSubmit = (credentials) => {
        setLoading(true);

        loginUser({
            ...credentials,
            username: toLower(credentials.username),
        })
            .then(userData => {
                setLoading(false);
                onSuccess && onSuccess(userData)
            })
            .catch((err) => {
                setLoading(false);
                clearAllAlerts();
                if (!err.response) {
                    addErrorAlert('We seem to have trouble connecting', 10 * 1000);
                } else if (err.response.status === 401) {
                    addErrorAlert(
                        'That username and password combination was incorrect.',
                        10 * 1000
                    );
                } else {
                    addErrorAlert('An unknown error occurred', 10 * 1000);
                
                }
                onError && onError(err);
            })

    };

    return (
        <BaseForm
            inputs={loginInputs}
            submitButtonText="Login"
            hideDefaultButtons
            onSubmit={onSubmit}
            otherButtons={
                <div className="is-fullwidth is-flex is-flex-direction-column is-justify-content-center">
                    <button
                        className={`button is-primary is-fullwidth is-medium ${isLoading ? 'is-loading' : ''}`}
                        type="submit"
                    >
                        Login
                    </button>
                </div>
            }
        />
    )
}

export default LoginForm